import { AppState } from 'store';
import { ICountry, IStateAndProvince } from 'core/models';

export const statesAndProvincesSelector = ({ locationsState }: AppState): IStateAndProvince[] =>
  locationsState?.statesAndProvinces;

export const countriesSelector = ({ locationsState }: AppState): ICountry[] => locationsState?.countries;
